import {CodeNodeDef} from "../../parser/definition/types/CodeNodeDef";
import {NodeDef} from "../../parser/definition/types/NodeDef";

export function isCodeNodeDef<I, O>(
  nodeDef: NodeDef<I, O>
): boolean {
  const codeNodeDef = nodeDef as CodeNodeDef<I, O>;
  return !!codeNodeDef.inputHandlers
    || codeNodeDef.initHandler
    || codeNodeDef.spreadInputHandlers
    || codeNodeDef.cleanupHandler;
}
